import * as actions from '../actions'

const defaultState = null

export default function publicFlows(state = defaultState, action) {
    switch (action.type) {
        case actions.GET_PUBLIC_FLOWS:
            if (!action.error) {
                state = action.payload.data
            }
            return state

        case actions.CLEAN_ALL:
        case actions.APP_SELECT:
        case actions.CLEAN_PUBLIC_FLOWS:
            return defaultState

        default:
            return state
    }
}
